module.exports = __webpack_public_path__ + "static/media/W18-1213_AW.CA_Desktop_2396x1473_EN.43d8c75a.jpg";